import { ASSETS, ASSETS_TYPES } from 'constants/assets'
// import { PRICE_FEED_SYMBOLS_DICT } from "constants/marketSymbols";
import { DateTime } from 'luxon'
import ms from 'ms.macro'

const DAYS_TO_BE_HOT = 8

const LVG_DEFAULT_ASSET_PARAM = {
  minLeverageAmount: 15,
  maxLeverageAmount: 10000,
  leverageRange: { min: 1, max: 100 },
}

const LVG_ASSETS_TYPES_PARAMS = {
  [ASSETS_TYPES.CRYPTO]: {
    minLeverageAmount: 15,
    maxLeverageAmount: 30000,
    leverageRange: { min: 1, max: 1000 },
  },
  [ASSETS_TYPES.STOCKS]: {
    minLeverageAmount: 15,
    maxLeverageAmount: 50000,
    leverageRange: { min: 1, max: 1000 },
  },
  [ASSETS_TYPES.YOLO_ETF]: {
    minLeverageAmount: 15,
    maxLeverageAmount: 30000,
    leverageRange: { min: 1, max: 1000 },
  },
  [ASSETS_TYPES.MEME_COIN]: {
    minLeverageAmount: 15,
    maxLeverageAmount: 5000,
    leverageRange: { min: 1, max: 50 },
  },
}

// We use the asset ID as key
const LVG_ASSETS_PARAMS = {
  'WLD/USD': {
    minLeverageAmount: 15,
    maxLeverageAmount: 10000,
  },
  'UNIBOT/USD': {
    leverageRange: { min: 1, max: 30 },
    maxLeverageAmount: 5000,
  },
  '1000PEPE/USD': {
    leverageRange: { min: 3, max: 250 },
  },
  '1000FLOKI/USD': {
    leverageRange: { min: 3, max: 250 },
  },
  '10000LADYS/USD': {
    leverageRange: { min: 3, max: 250 },
  },

  'RLB/USD': {
    leverageRange: { min: 1, max: 30 },
    maxLeverageAmount: 5000,
  },
  'FRIEND': {
    featured: true,
    leverageRange: { min: 1, max: 10 },
    maxLeverageAmount: 5000,
  },
  'YOLOCOASTER': {
    featured: true,
    maxBidAmount: 50,
    leverageRange: { min: 10, max: 1000 },
    alert: 'Rounds end every 15 minutes.',
    actions: [
      {
        actionId: 'showToastOnAssetChange',
        autoClose: ms`15s`,
        title: ' Bidding with $YOLOCOASTER has limits',
        subtitle:
          'Every YOLOCOASTER bid that is open longer than 15 seconds is forced closed at profit or loss at the point.  ',
      },
    ],
  },
  'PEPE/USD': {
    actions: [
      {
        actionId: 'showToastOnAssetChange',
        autoClose: ms`15s`,
        title: 'Bidding with $PEPE has limits ',
        subtitle:
          '$PEPE is in the experimental phase, and we have limited each bid to 5K max and 50x max for now due to high slippage and an illiquid market. Please leverage the bid with caution on $PEPE. We will increase the limit and leverage when the market is more liquid and stable.',
      },
    ],
    alert:
      'Leverage 10x or above is not recommended for $PEPE due to high slippage.',
  },
  'WOJAK/USD': {
    actions: [
      {
        actionId: 'showToastOnAssetChange',
        autoClose: ms`15s`,
        title: 'Bidding with $WOJAK has limits ',
        subtitle:
          '$WOJAK is in the experimental phase, and we have limited each bid to 5K max and 50x max for now due to high slippage and an illiquid market. Please leverage the bid with caution on $WOJAK. We will increase the limit and leverage when the market is more liquid and stable.',
      },
    ],
    alert:
      'Leverage 10x or above is not recommended for $WOJAK due to high slippage.',
  },

  'ETH/USD': {
    minLeverageAmount: 20,
  },
  'BBBY': {
    bidSideConstrain: 'sell',
  },
  'AMC': {
    bidSideConstrain: 'sell',
  },
  'GME': {
    bidSideConstrain: 'sell',
  },
  'SI': {
    bidSideConstrain: 'sell',
  },
  'FRC': {
    bidSideConstrain: 'sell',
  },
  'CS': {
    bidSideConstrain: 'sell',
  },
}

const FILTER_REGEX = /^lvg-/
export const LVG_ASSETS = ASSETS.filter((asset) =>
  asset.games.some((game) => FILTER_REGEX.test(game))
).map((asset) => {
  return {
    ...asset,
    ...LVG_DEFAULT_ASSET_PARAM,
    ...LVG_ASSETS_TYPES_PARAMS?.[asset.type],
    ...LVG_ASSETS_PARAMS?.[asset.id],
  }
})
export const getAssetsForGame = (game) =>
  ASSETS.filter((asset) => asset.games.includes(game)).map((asset) => {
    return {
      ...asset,
      ...LVG_DEFAULT_ASSET_PARAM,
      ...LVG_ASSETS_TYPES_PARAMS?.[asset.type],
      ...LVG_ASSETS_PARAMS?.[asset.id],
    }
  })

export const getAssetTypeByAssetId = (assetId) =>
  ASSETS.filter((asset) => asset.id === assetId).at(0)?.type

export const LVG_HOT_ASSETS = LVG_ASSETS.filter((asset) => {
  const assetDt = DateTime.fromSQL(asset.sqlDate)
  const todayDt = DateTime.now()
  const days = todayDt.diff(assetDt, 'days').toObject().days
  return days < DAYS_TO_BE_HOT
})
  .sort((a, b) => {
    const dateA = DateTime.fromSQL(a.sqlDate)
    const dateB = DateTime.fromSQL(b.sqlDate)
    const diff = dateA.diff(dateB).toObject().milliseconds
    if (diff > 0) return -1
    if (diff < 0) return 1
    return 0
  })
  .filter((asset) => !asset.featured)
